import React from 'react';
import styles from '../trace.module.scss';

export const TableFooterLabel = () => <span className={ styles.tableFooterLabel }>Quotes delayed by 4 hours</span>;
